import React from "react";
import {WidgetProps} from "./widget";
import {Input} from "antd";
import {useTranslate} from "../../../../../../hooks/translate.hook";
export const IntegerWidget: React.FC<WidgetProps> = ({onChange, value}) => {

    const t = useTranslate();

    return (
        <Input
            inputMode={"numeric"}
            placeholder={t("FILTER.VALUE")}
            onChange={v => onChange([v.target.value])}
            value={value[0]}
        />
    )
}